import { ApiAccount, ApiVault } from '../../../openapi';

export function detectFromTopUpAccount({
  defaultAccountId,
  accounts,
}: {
  defaultAccountId: string | undefined;
  accounts: ApiAccount[];
}): ApiAccount | undefined {
  let from: ApiAccount | undefined;
  if (defaultAccountId) {
    from = accounts.find((it) => it.id === defaultAccountId);
  }
  if (!from) {
    from = accounts.find((it) => it.purpose === 'BASE');
  }

  if (!from) {
    from = accounts[0];
  }

  return from;
}

export function detectTransferVault({
  defaultVaultId,
  vaults,
}: {
  defaultVaultId: string | undefined;
  vaults: ApiVault[];
}): ApiVault | undefined {
  let to = vaults.find((it) => it.id === defaultVaultId);
  if (!to) {
    to = vaults[0];
  }
  return to;
}

export function detectToWithdrawAccount({
  defaultAccountId,
  accounts,
  vault,
}: {
  defaultAccountId: string | undefined;
  accounts: ApiAccount[];
  vault: ApiVault | undefined;
}): ApiAccount | undefined {
  if (!vault) return undefined;

  let from: ApiAccount | undefined;
  if (defaultAccountId) {
    from = accounts.find((it) => it.id === defaultAccountId);
    if (from?.balance.currency !== vault.balance.currency) {
      from = undefined;
    }
  }
  if (!from) {
    from = accounts.find((it) => it.balance.currency === vault.balance.currency);
  }

  return from;
}
